export const EMPTY_RULE = {
  type: '', subtype: '', mode: '', vendor: '', modality_tag: '',
  dark_mode: false, monochrome: false, is_active: 0,
};

export const isRuleEmpty = (rule) => {
  const { is_active, dark_mode, monochrome, ...ruleFields } = rule || {};
  return !Object.values(ruleFields).some((v) => Boolean(v));
};

export const ruleFlagOn = (value) => value === true || value === 1 || value === '1';

export const cleanSendingRules = (rules, { isNew = false } = {}) =>
  (rules || [])
    .map((r) =>
      Object.fromEntries(Object.entries(r).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v]))
    )
    .map((r) => (isNew ? { ...r, is_active: 1 } : r))
    .filter((r) => !isRuleEmpty(r));
export const VENDORS = [
  { value: 'default', label: 'DEFAULT' },
  { value: 'sectra', label: 'SECTRA' },
  { value: 'medecom', label: 'MEDECOM' },
  { value: 'b3d', label: 'B3D' },
  { value: 'tps', label: 'TPS' },
  { value: 'ge', label: 'GE' },
  { value: 'visus', label: 'VISUS' },
];

export const REPORT_TYPE_OPTIONS = (t) => [
  { value: 'SR', label: t('Settings.report_type_sr') },
  { value: 'SC', label: t('Settings.report_type_sc') },
];

export const SR_SUBTYPE_OPTIONS = (t) => [
  { value: 'cad', label: t('Settings.cad') },
  { value: 'simple', label: t('Settings.simple') },
];

export const SC_SUBTYPE_OPTIONS = (t) => [
  { value: 'quality_core', label: t('Settings.quality_core') },
  { value: 'quality_detailed', label: t('Settings.quality_detailed') },
  { value: 'quality_ge', label: t('Settings.quality_ge') },
  { value: 'score_card', label: t('Settings.score_card') },
  { value: 'diagnostics', label: t('Settings.diagnostics') },
  { value: 'density', label: t('Settings.density') },
];

export const MODE_OPTIONS = (t) => [
  { value: 'manual', label: t('Settings.manual') },
  { value: 'automatic', label: t('Settings.direct') },
];

export const TAG_MODALITY_OPTIONS = [
  { value: 'SC', label: 'SC' },
  { value: 'MG', label: 'MG' },
];

export const REPORT_ITEMS = (t) => [
  {
    title: t('Settings.send_str_reports'),
    subtitle: t('Settings.str_report_detail'),
    image: 'SR_Report',
  },
  {
    title: t('Settings.send_report_scoreCard'),
    subtitle: t('Settings.scoreCard_report_detail'),
    image: 'ScoreCardReport',
  },
  {
    title: t('Settings.send_report_diagnostics'),
    subtitle: t('Settings.diagnostics_report_detail'),
    image: 'DiagnosticsReport',
  },
  {
    title: t('Settings.send_report_detailed'),
    subtitle: t('Settings.quality_report_detail'),
    image: 'QualityDetailedReport',
  },
  {
    title: t('Settings.send_report_core'),
    subtitle: t('Settings.core_report_detail'),
    image: 'QualityCoreReport',
  },
  {
    title: t('Settings.send_report_ge'),
    subtitle: t('Settings.ge_report_detail'),
    image: 'QualityDetailedReport',
  },
];
